module.exports = __webpack_public_path__ + "static/media/mall-slide.9afb53f8.png";